




































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { Simulation } from "@/api/models/creneaux/creneau";
import CreateSimulation from "./CreateSimulation.vue";
import UpdateSimulation from "./EditSimulation.vue";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BAlert,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BAlert,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    CreateSimulation,
    UpdateSimulation,
  },
})
export default class ListSimulations extends Vue {
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  isAddNewSimulationSidebarActive = false;
  isUpdateSimulationSidebarActive = false;
  selectedSimulationId = "";
  searchQuery = "";
  timeout: any = null;

  tableColumns = [{ key: "nom", sortable: true, label: "Nom" }, { key: "actions" }];
  paginatedListSimulations = new PaginatedList<Simulation>();

  async created() {
    await this.loadListSimulations({
      search: this.searchQuery,
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListSimulations.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListSimulations.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListSimulations({
      search: this.searchQuery,
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  // selectSimulation(simulationId: string) {
  //   this.$router.push({
  //     name: "details-simulation",
  //     params: { id: simulationId },
  //   });
  // }

  editSimulation(simulationId: any) {
    this.selectedSimulationId = simulationId;
    this.isUpdateSimulationSidebarActive = true;
  }

  @Watch('searchQuery')
  async searchSimulations() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListSimulations({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        search: this.searchQuery,
      })
    }, 1000);
  }

  async loadListSimulations(params: any) {
    if (!params || params?.reset) {
      this.paginatedListSimulations = new PaginatedList<Simulation>();
    }
    await this.$http.myressif.simulations
      .paginatedList(params?.search, params?.pageNumber ?? 1, params?.pageSize ?? 10)
      .then((response: PaginatedList<Simulation>) => {
        this.paginatedListSimulations = response;
      });
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cette simulation ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.simulations
      .delete(id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'une simulation",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-simulations");
        this.loadListSimulations({
          search: this.searchQuery,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        });
      });
  }
}
